import type {
  ItineraryListParams,
  ItineraryStatusPresentation,
} from "../types";

/** config 层导出入口（由脚手架生成）。 */
export * from "./itineraryConfig";

export const itineraryListDefaultParams: ItineraryListParams = {
  scope: "mine",
  sortBy: "updated_at",
  sortOrder: "desc",
  page: 1,
  pageSize: 20,
};

export const itineraryListPageSizeOptions = [20, 50, 100];

/** 窄屏课程线路卡片列表默认每页条数，避免一次加载过多。 */
export const itineraryListMobilePageSize = 5;

/** 移动端课程线路仅保留的范围。 */
export const itineraryListMobileScopes = ["mine", "recent_3y"] as const;

export const itineraryStatusPresentations: Record<string, ItineraryStatusPresentation> = {
  confirmed: { label: "定稿", color: "green" },
  reviewing: { label: "审稿", color: "blue" },
  active: { label: "草稿", color: "orange" },
  draft: { label: "草稿", color: "orange" },
  archived: { label: "已归档", color: "gray" },
};
